import iconDependency from '@/dependencies/iconDependency'

const leftMenu = () => {
  const iconSvg = iconDependency()
  return [
    {
      name: 'BERANDA',
      items: [
        {
          icon: iconSvg.home,
          label: 'Dashboard',
          route: 'dashboard',
          items: [],
          prohibitedRoles: []
        },
      ],
      prohibitedRoles: []
    },
    {
      name: 'MASTER',
      items: [
        {
          icon: iconSvg.masterRoute,
          label: 'Master Karyawan',
          route: 'master-employee',
          prohibitedRoles: []
        },
        {
          icon: iconSvg.masterPrice,
          label: 'Master Divisi',
          route: 'master-position',
          prohibitedRoles: []
        },
        {
          icon: iconSvg.masterExpenses,
          label: 'Master Dokumen',
          route: 'master-document-type',
          prohibitedRoles: []
        },
        {
          icon: iconSvg.location,
          label: 'Master Wilayah',
          route: 'master-region',
          prohibitedRoles: []
        },
        {
          icon: iconSvg.office,
          label: 'Master Gedung',
          route: 'master-building',
          prohibitedRoles: []
        },
        {
          icon: iconSvg.masterPenaltyFineType,
          label: 'Master Kategori Denda',
          route: 'master-penalty-fine-category',
          prohibitedRoles: []
        },
      ],
      prohibitedRoles: []
    },
    {
      name: 'KARTU KARYAWAN',
      items: [
        {
          icon: iconSvg.employeeViolationCard,
          label: 'Kartu Pelanggaran',
          route: 'violation-card',
          prohibitedRoles: []
        },
      ],
      prohibitedRoles: []
    },
  ]
}

export default leftMenu
